import { EmptyDataMessage } from "@/common/components/EmptyDataMessage";
import { cn } from "@/common/utils/cn";
import { formatCurrency } from "@/common/utils/formatters";
import { branchesEquipmentsConsumptionsTotalizerColumns } from "@/features/movementsTotalizer/constants/branchesEquipmentsConsumptionsTotalizerColumns.constant";
import { BranchesEquipmentsConsumptionsTotalizerData } from "@/features/movementsTotalizer/types/branchesEquipmentsConsumptionsTotalizer.type";
import BranchRow from "./BranchRow";

interface BranchesEquipmentsConsumptionsTotalizerTableProps {
  className?: string;
  print?: boolean;
  data: BranchesEquipmentsConsumptionsTotalizerData | undefined;
}

const BranchesEquipmentsConsumptionsTotalizerTable = ({
  className,
  print,
  data,
}: BranchesEquipmentsConsumptionsTotalizerTableProps) => {
  return (
    <div className={cn(
      `flex-1 flex flex-col overflow-hidden rounded-lg
      print:text-black print:bg-white-800 print:rounded print:overflow-visible`,
      className,
    )}>
      {Number(data?.branches?.length) === 0 && !print && (
        <EmptyDataMessage className="flex-1" />
      )}

      {Number(data?.branches?.length) === 0 && print && (
        <div className="flex-1">
          <table className="text-base w-full table-fixed">
            <tbody>
              <tr>
                <td className="text-center py-8">
                  Não há registros para serem visualizados
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {Number(data?.branches?.length) !== 0 && (
        <div className="flex-1 overflow-auto thin-scroll rounded-lg">
          <table className={cn(
            'text-sm w-full',
            !print && 'whitespace-nowrap'
          )}>
            <colgroup>
              {branchesEquipmentsConsumptionsTotalizerColumns.map((col) => (
                <col key={col.value} className={cn(!print && 'min-w-40')} />
              ))}
            </colgroup>

            <thead className="sticky top-0 z-10 rounded-l-lg">
              <tr
                className={`
                  bg-[#212023] [&>*:first-child]:border-l-0 [&>*:last-child]:border-r-0 rounded-l-lg
                  print:bg-neutral-400/65 print:border-x print:border-x-neutral-400/65
                `}
              >
                {branchesEquipmentsConsumptionsTotalizerColumns.map((column) => (
                  <th
                    key={column.value}
                    className={`
                    text-left px-4 py-6 border-x border-x-[#64676980] text-sm font-bold first:rounded-l-lg
                    print:'px-2 print:py-2 print:first:rounded-l-none print:border-neutral-500',
                  `}
                  >
                    {column.label}
                  </th>
                ))}
              </tr>
            </thead>

            {data?.branches?.map((branch) => (
              <BranchRow
                key={branch.id}
                branch={branch}
              />
            ))}

            {print && (
              <tbody>
                <tr>
                  <td colSpan={branchesEquipmentsConsumptionsTotalizerColumns.length} className="p-0 border-x border-neutral-400/50">
                    <div className="flex items-center justify-between gap-8 p-3 rounded-b-none bg-neutral-400/50 print:font-semibold">
                      <p className="">
                        Valor total das filiais
                      </p>

                      <p>
                        {(data?.total_value && formatCurrency(Number(data.total_value))) || '--'}
                      </p>
                    </div>
                  </td>
                </tr>
              </tbody>
            )}
          </table>
        </div>
      )}
    </div>
  );
}

export default BranchesEquipmentsConsumptionsTotalizerTable;
